module.exports = __webpack_public_path__ + "img/emptycapture.415303cd.svg";